import { createFeatureSelector, createSelector } from "@ngrx/store";
import { PlanInternet } from "..";

export const planInternetStateSelector =
	createFeatureSelector<PlanInternet>("plan");
export const planInternetViewSelector = createSelector(
	planInternetStateSelector,
	(state) => state?.internet?.view
);
